// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2JzCQ","col":"styles_col__1bwF_"};